import { render } from "./HeroiconsOutlineCube.vue?vue&type=template&id=07e46786"
const script = {}

import exportComponent from "/Users/crynobone/Projects/laravel/nova/aries/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineCube.vue"]])

export default __exports__